// extracted by mini-css-extract-plugin
module.exports = {"Panel":"ua_Panel__kArTw","LP":"ua_LP__d1Eim"};